import { DocumentModel } from '../../../../shared/models/simple-types/document.model';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ChangeDetectorRef, Component, HostListener, Inject, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { BcComponentsService } from '../../bc-components.service';
import { UntypedFormControl, UntypedFormGroup, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { validatorFileSize, validatorFileType } from 'src/app/shared/fileValidators';

export interface DialogData {
  idBc: number;
  documents: DocumentModel[];
}

@Component({
  selector: 'app-modal-add-bc-document',
  templateUrl: './modal-add-bc-document.component.html',
  styleUrls: ['./modal-add-bc-document.component.scss'],
})

export class ModalAddBcDocumentComponent implements OnInit {

  public form: UntypedFormGroup;
  filename: string;
  file: File;
  progress = 0;
  ext: string;
  libelleControl: UntypedFormControl;
  fileControl: UntypedFormControl;
  result = false;
  constructor(public dialog: MatDialog,
              private toastr: ToastrService,
              public router: Router,
              private bcService: BcComponentsService,
              public dialogRef: MatDialogRef<Component>,
              @Inject(MAT_DIALOG_DATA) public data: DialogData,
              private changeDetectorRef: ChangeDetectorRef) {
    this.libelleControl = new UntypedFormControl(null, Validators.required);
    this.fileControl = new UntypedFormControl(null, [Validators.required, validatorFileSize(16000000)]);
    this.form = new UntypedFormGroup({
      file: this.fileControl,
      libelle: this.libelleControl
    });
  }
  @HostListener('change', ['$event.target.files']) emitFiles(event: FileList) {
    const file = event && event.item(0);
    this.file = file;
    if (!this.libelleControl.value) {
      this.libelleControl.setValue(file?.name);
    }
  }
  ngOnInit(): void {
  }

  onModalCancel(): void {
    this.dialogRef.close(this.result);
  }

  submit(): void {
    if (this.form.valid) {
      this.file = this.fileControl.value;
      this.libelleControl.setValue(this.libelleControl.value.replace(/[\W_]+/g, "-"));
      var length = this.file.name.split('.').length;
      const extension = length > 1 ? this.file.name.split('.')[length - 1].toLowerCase() : null;
      this.filename = extension ? this.libelleControl.value + '.' + extension : this.libelleControl.value;
      this.bcService.sendDocument(this.filename, this.data.idBc, this.file).subscribe((res) => {
        this.progress = res;
        if (res === 100) {
          this.result = true;
          this.toastr.success('Le fichier : ' + this.filename + ' à bien été enregistré.');
          this.form.enable();
          this.libelleControl.reset('', {emitEvent: false});
          this.libelleControl.markAsUntouched();
          this.fileControl.reset('', {emitEvent: false});
          this.fileControl.markAsUntouched();
          this.changeDetectorRef.detectChanges();
          this.dialogRef.close(this.result);
        } else if (res === -1) {
          this.progress = 0;
          this.form.enable();
          this.toastr.warning('Le fichier : ' + this.filename + ' éxiste déjà pour ce bc');
        } else {
          this.form.disable();
        }
      });
    }
  }
}
